<section class="mat-typography main-heading center">
  <br />
  <h1>Raw Transaction Report</h1>
</section>
@if (!loading) {
<div class="form-group padded-side-nav">
  @if (!resetHeader) {
<div class="search-bar">
    <app-generic-table-header
      [config]="headerOptions"
      (dropdownSelected)="getDropdowns($event)"
      (clearPressed)="reset()"
      (exportPressed)="downloadReport()"
      (dateRangeChange)="setDate($event)"
      (viewPressed)="EnquireReportInfo()"></app-generic-table-header>
  </div>
}
  @if (!resetHeader) {
<div class="instructions mat-typography">
    Select a date range, group, server, server link and/or APN to begin report
    generation.
  </div>
}

  @if (!loading && reportResults != null && reportResults.length > 0) {
<div>
    <div class="heading mat-typography center">
      Results
    </div>
    <app-card-table
      [data]="reportResults"
      [tableHeaders]="resultsHeaders"
      [options]="options"
      [enableInfiteScroll]="false"
      [enableTablePagination]="true"
      [enableRefresher]="false"
      [totalItems]="reportResults.length"
      [currentPage]="currentPage"
      (paginateEvent)="onPageChange($event)"
      [breakpoint]="ScreenSize.TABLET">
    </app-card-table>
  </div>
}
  @if ( enquired && (reportResults == null || reportResults.length == 0)) {
<div class="mat-typography no-data center"
   >
    No Data Available
  </div>
}
</div>
}
@if (loading) {
<div class="flex-center">
  <mat-spinner></mat-spinner>
</div>
}